<template>
  <v-container fluid>
    <!-- <el-overlay-loading :loading="pageloading" /> -->
    <h3 class="mb-5">Sutarties šalys</h3>

    <hipoteka-asmenys :asmuo-role="asmuoRole" :readonly="isReadonlyForm" />

    <hipoteka-istorija duomenys="sutarties-salys" />

    <v-footer class="form-footer">
      <v-spacer></v-spacer>
      <el-button primary @click.native="checkErrors()">Tikrinti</el-button>
    </v-footer>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import checkErrors from '../../mixins/checkErrors'
import HipotekaMap from './../hipoteka/hipotekaMap'
import HipotekaAsmenys from './../hipoteka/HipotekaAsmenys'
import HipotekaIstorija from './../hipoteka/istorija/HipotekaIstorija'

export default {
  name: 'SutartisSalys',
  components: {
    HipotekaAsmenys,
    HipotekaIstorija,
  },
  mixins: [checkErrors],
  props: {
    readonlyForm: { type: Boolean, default: false },
  },
  data() {
    return {
      //
    }
  },
  computed: {
    ...mapGetters(['objektasID', 'hipotekaTipas', 'hipotekaReadonly']),
    asmuoRole() {
      return HipotekaMap['asmenysRoles'].sutartis
    },
    isSutartisPageidavimas() {
      return this.hipotekaTipas.includes('pageidavimas')
    },
    isSutartisAtsaukimas() {
      return this.hipotekaTipas.includes('atsaukimas')
    },
    isReadonlyForm() {
      return (
        this.isSutartisPageidavimas ||
        this.isSutartisAtsaukimas ||
        this.hipotekaReadonly ||
        this.readonlyForm
      )
    },
  },
  created() {
    //
  },
  methods: {
    //
  },
}
</script>
